export default function guest ({ next}){
    let user = JSON.parse(localStorage.getItem("user"));
    if(user!=null){
        return next({
            name: 'Home'
        })
    }
    return next()
}